<template>
  <b-modal id="modal-last-chance-hd" centered hide-header>
    <div class="d-block text-center">
      <Icon name="grAlarmClock" width="36" class="mb-3"/>
      <h1 class="modal-title mb-3" v-if="title">{{title}}</h1>
      <h3 class="modal-subtitle" v-html="message"></h3>
    </div>

    <template #modal-footer="{ ok, cancel }">
      <div class="row w-100 justify-content-center">
        <div class="col-sm-6 order-sm-1 mb-2 mb-sm-0">
          <b-button variant="primary" block @click="ok()">
            {{ labelCta }}
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>


export default {
  name: "ModalRetention",
  props: {
    title: {
      type: String,
      required: false,
    },
    message: {
      type: String,
      required: true,
    },
    labelCta: {
      type: String,
      default: "OK",
    },
  },
}
</script>

